module.exports = __webpack_public_path__ + "static/assets/2ede3b1977411d39f0cc8ba0a973e25c.svg";